var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 15,
  height: 15,
  viewBox: "0 0 15 15"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Icon_feather-clock",
  "data-name": "Icon feather-clock",
  transform: "translate(-0.833 -0.833)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_119",
  "data-name": "Path 119",
  d: "M15.333,8.333a7,7,0,1,1-7-7,7,7,0,0,1,7,7Z",
  transform: "translate(0 0)",
  fill: "none",
  stroke: "#898989",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_120",
  "data-name": "Path 120",
  d: "M8,4V8l2.667,1.333",
  transform: "translate(0.417 0.222)",
  fill: "none",
  stroke: "#898989",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}))));
export default __webpack_public_path__ + "static/media/RestockingWatch.37852170.svg";
export { SvgComponent as ReactComponent };